'use es6';

const defaults = {
  name: '',
  companyName: '',
  companyStreetAddress_1: '',
  companyStreetAddress_2: '',
  companyCity: '',
  companyState: '',
  companyZip: '',
  companyCountry: '',
  companyPhone: '',
  isDefault: false,
  id: -1,
  author: '',
  authorAt: 0,
  created: 0,
  deletedAt: 0,
  isValid: false,
  portalId: 0,
  updated: 0
};
function CanSpamSetting(json = {}) {
  return Object.assign({}, defaults, json);
}
export default CanSpamSetting;